// import React from 'react'
import styled from 'styled-components'

export const GenericContainer = styled.div`
  display: flex;
  position: relative;
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '100%')};
  flex-direction: ${(props) => (props.fDir ? props.fDir : 'unset')};
  z-index: 1;
`

export const ScreenContainer = styled.div`
  display: flex;
  width: 1920px;
`

export const LeftGradientSection = styled.div`
  width: 50%;
  height: 100%;
  background-image: linear-gradient(130deg, #fe0d9f 1%, #faae01 90%);
  background-size: cover;
  background-size: 115% 115%;
  background-position-y: 15%;
  /* padding-left: 10.8vw; */
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  justify-content: center;
`

export const GenericIconButton = styled.button`
  position: ${(props) => (props.position ? props.position : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  width: ${(props) => (props.width ? props.width : 'unset')};
  height: ${(props) => (props.height ? props.height : 'unset')};
  border: ${(props) => (props.border ? props.border : 'none')};
  background: ${(props) =>
    props.backgroundUrl ? `url(${props.backgroundUrl})` : 'none'};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease-in-out;

  :hover {
    transform: scale(1.1);
  }
`
